import * as React from 'react'
import { FaIcon, faClose } from '@/lib/fa'
import { useDriverForm } from '../../context/DriverFormContext'
import { useLocalize } from '@/modules/shared/context/localize/LocalizeContext'
import { Switch } from '@/ui/form/primitives/Switch'
import Navigation from '../shared/Navigation'
const AddDriverHeader = ({ close }: { close: any }) => {
  const { t } = useLocalize()
  const { setFormType, isFullForm, formType, isEditState } = useDriverForm()
  return (
    <div className="tw-border-b tw-border-base-300">
      <div
        className={`tw-flex tw-flex-col tw-gap-6 tw-py-4 ${isFullForm ? 'tw-pb-0' : ''}`}
      >
        <div className="tw-flex tw-items-center tw-justify-between tw-px-4">
          <p className="tw-text-xl tw-font-semibold tw-text-content-base">
            {isEditState ? t('driverModule.editing-driver') : t('driverModule.adding-driver')}
          </p>
          <FaIcon
            icon={faClose}
            className="tw-h-5 tw-w-5 tw-cursor-pointer"
            onClick={() => close()}
          />
        </div>
        <div className="tw-flex tw-items-center tw-gap-3 tw-px-4">
          <Switch
            checked={isFullForm}
            onChange={(e) => {
              e.target.checked
                ? setFormType('full-basic')
                : setFormType('simple')
            }}
          />
          <p className="tw-text-sm tw-font-medium tw-text-content-base">
            {t('driverModule.full-form')}
          </p>
        </div>
        {isFullForm && (
          <div className="tw-flex tw-items-center tw-gap-2">
            <Navigation
              isActive={formType === 'full-basic'}
              onClick={() => setFormType('full-basic')}
            >
              {t('driverModule.basic-info')}
            </Navigation>
            <Navigation
              isActive={formType === 'full-additional'}
              onClick={() => setFormType('full-additional')}
            >
              {t('driverModule.additional-info')}
            </Navigation>
          </div>
        )}
      </div>
    </div>
  )
}

export default AddDriverHeader
